export default __webpack_public_path__ + "static/media/marigold.7fbcbae1.png";